import React, { useEffect, useState, useRef } from "react";
import { Formik } from "formik";
import Swal from "sweetalert2";
import * as authService from "../../services/auth.services";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../../../src/assets/admin/img/logos/logo-1.svg";
import {
  getSessionKey,
  handleNavigation,
  handleServerValidations,
  removeSessionKey,
  setLocalKey,
  setSessionKey,
  removeLocalKey,
} from "../../../../utils/commonfunction";
import { SWAL_SETTINGS, COOKIES_EXPIRATION, PASSWORD_MIN_LENGTH, ROLE } from "../../../../utils/Constants";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { addProfileData } from "../../../../redux/slices/profileslice";


const Login = () => {
  const [show, setShow] = useState(true);
  const [loader, setLoader] = useState(false);
  // const [logo, setLogo] = useState("");
  const formikRef = useRef(null);
  const { t } = useTranslation();
  const Dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("logout") === "true") {
      removeLocalKey(ROLE.SUPER_ADMIN);
      Dispatch(addProfileData({}));
      navigate("/", { replace: true });
    }
  }, [navigate, Dispatch]);

  /** Remember last logged-in user >>>> */
  useEffect(() => {
    // Defense: proactively remove any legacy insecure password cookie
    Cookies.remove("password");
    const storedUsername = Cookies.get("email") || Cookies.get("username");
    if (storedUsername) {
      formikRef?.current?.setFieldValue("email", storedUsername);
    }
  }, []);
  /** Remember last logged-in user <<<< */

  const handleshow = () => {
    setShow(!show);
  };

  function handleRememberMe(e) {
    if (e.target.checked) {
      setSessionKey("remember-me", "true");
    } else {
      removeSessionKey("remember-me");
      Cookies.remove("email");
      Cookies.remove("username");
      Cookies.remove("password");
    }
  }


  return (
    <>
      <Formik
        initialValues={{ email: "", password: "" }}
        innerRef={formikRef}
        validate={(values) => {
          const errors = {};
          if (!values.email) {
            errors.email = t("label_email_error");
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = t("validation_err_invalid_email");
          }
          if (!values.password) {
            errors.password = t("validation_password_required");
          } else {
            let trimmedPass = values.password.trim();
            if (trimmedPass.length === 0) {
              errors.password = t("validation_password_required")
            }
            //   else if (trimmedPass.length < PASSWORD_MIN_LENGTH) {
            //     errors.password = t("msg_validation_password_length");
            // }
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          setLoader(true);
          // console.log("🚀 ~ Login ~ values:", values);

          let formData = new FormData();
          formData.append("email", values.email);
          formData.append("password", values.password);

          authService
            .portalLogin(formData)
            .then(async (response) => {
              setLoader(false);
              if (response.success) {
                if (getSessionKey("remember-me") === "true") {
                  Cookies.set("email", response?.data?.email, {
                    expires: COOKIES_EXPIRATION,
                    secure: window.location.protocol === "https:",
                    sameSite: "strict"
                  });
                } else {
                  Cookies.remove("email");
                  Cookies.remove("username");
                }
                Cookies.remove("password");
                
                setLocalKey(ROLE.SUPER_ADMIN, JSON.stringify(response.data));
                setLocalKey("is_customer_portal", "true");
                Dispatch(addProfileData(response.data));

                navigate("/onboarding/billing");

              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
              }
            })
            .catch((error) => {
              setLoader(false);
              console.log("error: ", error);
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          // and other goodies
        }) => (
          <div className="page main-signin-wrapper" style={{
            background: "linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 50%, #80cbc4 100%)",
            backgroundSize: "200% 200%",
            animation: "gradientBG 10s ease infinite",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px"
          }}>
            <style>{`
              @keyframes gradientBG {
                0% { background-position: 0% 50%; }
                50% { background-position: 100% 50%; }
                100% { background-position: 0% 50%; }
              }
              .glass-card {
                background: rgba(255, 255, 255, 0.85);
                backdrop-filter: blur(20px);
                -webkit-backdrop-filter: blur(20px);
                border-radius: 24px;
                border: 1px solid rgba(255, 255, 255, 0.4);
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
                overflow: hidden;
                width: 100%;
                max-width: 900px;
                display: flex;
              }
              .glass-input {
                background: rgba(255, 255, 255, 0.9) !important;
                border: 1px solid rgba(0, 0, 0, 0.1) !important;
                border-radius: 12px !important;
                padding: 14px 20px !important;
                font-size: 15px !important;
                transition: all 0.3s ease !important;
              }
              .glass-input:focus {
                background: #fff !important;
                border-color: #00897b !important;
                box-shadow: 0 0 0 4px rgba(0, 137, 123, 0.15) !important;
              }
              .glass-btn {
                background: linear-gradient(to right, #00897b, #00695c) !important;
                border: none !important;
                border-radius: 12px !important;
                color: #fff !important;
                font-weight: 600 !important;
                font-size: 16px !important;
                padding: 14px !important;
                transition: transform 0.2s ease, box-shadow 0.2s ease !important;
              }
              .glass-btn:hover {
                transform: translateY(-2px) !important;
                box-shadow: 0 10px 20px -10px rgba(0, 105, 92, 0.6) !important;
              }
              .glass-left {
                background: linear-gradient(135deg, rgba(38,166,154,0.95) 0%, rgba(0,105,92,0.95) 100%);
                padding: 40px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: white;
                text-align: center;
              }
            `}</style>
            
            <div className="glass-card">
              <div className="col-lg-5 d-none d-lg-flex glass-left">
                <img src={logo} alt="logo" style={{ maxWidth: '180px', marginBottom: '30px', filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.1))' }} />
                <h3 style={{ fontWeight: '700', marginBottom: '15px' }}>Customer Portal</h3>
                <p style={{ opacity: 0.9, lineHeight: '1.6' }}>Manage your billing, view invoices, and update payment methods securely.</p>
              </div>
              
              <div className="col-lg-7 col-12" style={{ padding: '50px 40px', background: '#fff' }}>
                <form onSubmit={handleSubmit}>
                  <h4 style={{ fontWeight: '700', color: '#2d3436', marginBottom: '8px' }}>Sign in to your account</h4>
                  <p style={{ color: '#636e72', marginBottom: '30px' }}>Enter your credentials to access the portal</p>
                  
                  <div className="form-group text-left mb-4">
                    <label style={{ fontWeight: '600', color: '#2d3436', marginBottom: '8px', display: 'block' }}>Email Address</label>
                    <input
                      className={"form-control glass-input" + (errors.email && touched.email ? " is-invalid" : "")}
                      placeholder="name@company.com"
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      autoComplete="off"
                    />
                    <span className="text-danger" style={{ fontSize: '13px', marginTop: '5px', display: 'block' }}>
                      {errors.email && touched.email && errors.email}
                    </span>
                  </div>
                  
                  <div className="form-group text-left mb-4">
                    <label style={{ fontWeight: '600', color: '#2d3436', marginBottom: '8px', display: 'block' }}>Password</label>
                    <div className="input-group">
                      <input
                        className={"form-control glass-input" + (errors.password && touched.password ? " is-invalid" : "")}
                        placeholder="••••••••"
                        type={!show === true ? "text" : "password"}
                        name="password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                        autoComplete="off"
                        style={{ borderRight: 'none', borderTopRightRadius: '0 !important', borderBottomRightRadius: '0 !important' }}
                      />
                      <span
                        className="input-group-text cp"
                        onClick={handleshow}
                        style={{ background: 'transparent', border: '1px solid rgba(0,0,0,0.1)', borderLeft: 'none', borderRadius: '0 12px 12px 0', cursor: 'pointer' }}
                      >
                        {!show === true ? <i className="far fa-eye-slash" style={{ color: '#636e72' }}></i> : <i className="far fa-eye" style={{ color: '#636e72' }}></i>}
                      </span>
                    </div>
                    <span className="text-danger" style={{ fontSize: '13px', marginTop: '5px', display: 'block' }}>
                      {errors.password && touched.password && errors.password}
                    </span>
                  </div>
                  
                  <div className="d-flex justify-content-between align-items-center mb-4">
              
               
                  </div>
                  
                  <button className={"btn btn-block glass-btn" + (loader === true ? " disabled" : "")} type="submit" disabled={loader}>
                    {loader === true ? (
                      <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" style={{ width: '1rem', height: '1rem', marginRight: '8px' }}></span>
                    ) : null}
                    {loader ? "Signing in..." : "Sign In"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};
export default Login;
